/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsshareeventhint3Inputs */

const en_groupsshareeventhint3 = /** @type {(inputs: Groupsshareeventhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event appears as a card in the chat. If it sells tickets, everyone can get them right there.`)
};

const de_groupsshareeventhint3 = /** @type {(inputs: Groupsshareeventhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Event erscheint als Karte im Chat. Verkauft es Tickets, können alle sie direkt dort holen.`)
};

/**
* | output |
* | --- |
* | "The event appears as a card in the chat. If it sells tickets, everyone can get them right there." |
*
* @param {Groupsshareeventhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsshareeventhint3 = /** @type {((inputs?: Groupsshareeventhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsshareeventhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsshareeventhint3(inputs)
	return de_groupsshareeventhint3(inputs)
});
export { groupsshareeventhint3 as "groupsShareEventHint" }